"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommandContractInfo = exports.getDefinitionForCommandAddress = exports.getDefinitionForCommandType = exports.getCommandAddresses = exports.defaultCommandTypeMapping = exports.commandAddressMapping = exports.commandTypeJsonMapping = void 0;
const types_1 = require("./types");
exports.commandTypeJsonMapping = {
    [types_1.CommandContractType.CloseCommand]: ['cdpId', 'triggerType', 'collRatio'],
    [types_1.CommandContractType.BasicBuyCommand]: [
        'cdpId',
        'triggerType',
        'execCollRatio',
        'targetCollRatio',
        'maxBuyPrice',
        'continuous',
        'deviation',
        'maxBaseFeeInGwei',
    ],
    [types_1.CommandContractType.BasicSellCommand]: [
        'cdpId',
        'triggerType',
        'execCollRatio',
        'targetCollRatio',
        'minSellPrice',
        'continuous',
        'deviation',
        'maxBaseFeeInGwei',
    ],
    [types_1.CommandContractType.AutoTakeProfitCommand]: [
        'cdpId',
        'triggerType',
        'executionPrice',
        'maxBaseFeeInGwei',
    ],
    [types_1.CommandContractType.SimpleAAVESellCommand]: [
        'positionAddress',
        'triggerType',
        'amount',
        'interval',
        'recipient',
    ],
    [types_1.CommandContractType.AaveStopLossCommand]: [
        'positionAddress',
        'triggerType',
        'collateralToken',
        'debtToken',
        'ltv',
    ],
    [types_1.CommandContractType.AaveStopLossCommandV2]: [
        'positionAddress',
        'triggerType',
        'maxCoverage',
        'debtToken',
        'collateralToken',
        'ltv',
    ],
    [types_1.CommandContractType.MakerStopLossCommandV2]: [
        'cdpId',
        'triggerType',
        'maxCoverage',
        'collRatio',
    ],
    [types_1.CommandContractType.MakerBasicBuyCommandV2]: [
        'cdpId',
        'triggerType',
        'maxCoverage',
        'execCollRatio',
        'targetCollRatio',
        'maxBuyPrice',
        'deviation',
        'maxBaseFeeInGwei',
    ],
    [types_1.CommandContractType.MakerBasicSellCommandV2]: [
        'cdpId',
        'triggerType',
        'maxCoverage',
        'execCollRatio',
        'targetCollRatio',
        'minSellPrice',
        'deviation',
        'maxBaseFeeInGwei',
    ],
    [types_1.CommandContractType.MakerAutoTakeProfitCommandV2]: [
        'cdpId',
        'triggerType',
        'maxCoverage',
        'executionPrice',
        'maxBaseFeeInGwei',
    ],
};
exports.commandAddressMapping = Object.fromEntries(Object.entries({
    [types_1.EthereumNetwork.GOERLI]: {
        '0xd0ca9883e4918894dd517847eb3673d656ec9f2d': { type: types_1.CommandContractType.CloseCommand },
        '0x31285a87fb70a62b5aaa43199e53221c197e1e3f': { type: types_1.CommandContractType.CloseCommand },
        '0x7c86781a95b7e55e6c2f7297ae6773e1dbceab13': {
            type: types_1.CommandContractType.BasicBuyCommand,
            overwrite: ['uint256', 'uint16', 'uint256', 'uint256', 'uint256', 'bool', 'uint64'],
        },
        '0xe3ae7218d8e4a482e212ef1cbf2fcd0fb9882cc7': { type: types_1.CommandContractType.BasicBuyCommand },
        '0x98b2b67795171380a4bfb5b8cd2f59aea768b3ed': { type: types_1.CommandContractType.BasicBuyCommand },
        '0x2003dc19056ba986b7d10ab4704897d685dd62d9': { type: types_1.CommandContractType.BasicBuyCommand },
        '0xf19ae4c34e0e0db13d074876a12339e86dc12f06': { type: types_1.CommandContractType.BasicBuyCommand },
        '0xd4f94e013c7f47b989ea79c6527e065c027794c7': {
            type: types_1.CommandContractType.BasicSellCommand,
            overwrite: ['uint256', 'uint16', 'uint256', 'uint256', 'uint256', 'bool', 'uint64'],
        },
        '0x6f878d8eb84e48da49900a6392b8f9ed262a50d7': { type: types_1.CommandContractType.BasicSellCommand },
        '0x3da3e38bbe1100de5247617b4554115c0e452416': { type: types_1.CommandContractType.BasicSellCommand },
        '0xb52b1c61c667d570ff62745b19a0c58011a4b32c': { type: types_1.CommandContractType.BasicSellCommand },
        '0x2ecc5086ce10194175607d0d082fc27c3416693d': { type: types_1.CommandContractType.BasicSellCommand },
        '0x940a17668197f71dcaefd77bf8c43c001c77f5ac': { type: types_1.CommandContractType.BasicSellCommand },
        '0x02b7391cdd0c8a75ecfc278d387e3dcc3d796340': {
            type: types_1.CommandContractType.AutoTakeProfitCommand,
        },
        '0x7b548daF6c7057449a57c08b9d34e352dB220E3B': {
            type: types_1.CommandContractType.SimpleAAVESellCommand,
        },
        '0xE78ACEa26B79564C4D29D8c1f5bAd3D4E0414676': {
            type: types_1.CommandContractType.AaveStopLossCommand,
        },
    },
    [types_1.EthereumNetwork.MAINNET]: {
        '0xa553c3f4e65a1fc951b236142c1f69c1bca5bf2b': { type: types_1.CommandContractType.CloseCommand },
        '0x05fb55553e54afb33a5acc1f23b1f4fffd0d1af9': { type: types_1.CommandContractType.BasicBuyCommand },
        '0xd36729c7cac24e47dc32ffd7d433f965caaeb912': { type: types_1.CommandContractType.BasicBuyCommand },
        '0x31285a87fb70a62b5aaa43199e53221c197e1e3f': { type: types_1.CommandContractType.BasicBuyCommand },
        '0xa6bd41b821972e83d30598c5683efbbe6ad70fb8': { type: types_1.CommandContractType.BasicSellCommand },
        '0xf9469da48f9d2ea87e195e3dd522226e876a1185': { type: types_1.CommandContractType.BasicSellCommand },
        '0x5588d89a3c68e5a87cafe6b79ef8caa667a702f1': { type: types_1.CommandContractType.BasicSellCommand },
        '0x7c0d6d8d6eae8bcb106afdb3a21df5c254c6c0b2': { type: types_1.CommandContractType.BasicSellCommand },
        '0xc6ccab5d277d4780998362a418a86032548132b8': {
            type: types_1.CommandContractType.AutoTakeProfitCommand,
        },
        '0xcb1e2f1df93bb5640562dad05c15f7677bf17297': {
            type: types_1.CommandContractType.AutoTakeProfitCommand,
        },
        '0xE78ACEa26B79564C4D29D8c1f5bAd3D4E0414676': {
            type: types_1.CommandContractType.AaveStopLossCommand,
        },
        '0xcEF8EB2D43DC1db1AB292Cb92F38Dd406EE5749f': {
            type: types_1.CommandContractType.AaveStopLossCommand,
        },
        '0x65127d52aaeb356b45c6dcb3da36f4fc6ff738ef': {
            type: types_1.CommandContractType.AaveStopLossCommandV2,
        },
        '0xDC1c84Aac43F21f103e9bD0B091a1B5cc6433554': {
            type: types_1.CommandContractType.AaveStopLossCommandV2,
        },
    },
}).map(([network, mapping]) => [
    network,
    Object.fromEntries(Object.entries(mapping).map(([address, config]) => [address.toLowerCase(), config])),
]));
exports.defaultCommandTypeMapping = {
    [types_1.CommandContractType.CloseCommand]: ['uint256', 'uint16', 'uint256'],
    [types_1.CommandContractType.SimpleAAVESellCommand]: [
        'address',
        'uint16',
        'uint256',
        'uint256',
        'address',
    ],
    [types_1.CommandContractType.AutoTakeProfitCommand]: ['uint256', 'uint16', 'uint256', 'uint32'],
    [types_1.CommandContractType.BasicBuyCommand]: [
        'uint256',
        'uint16',
        'uint256',
        'uint256',
        'uint256',
        'bool',
        'uint64',
        'uint32',
    ],
    [types_1.CommandContractType.BasicSellCommand]: [
        'uint256',
        'uint16',
        'uint256',
        'uint256',
        'uint256',
        'bool',
        'uint64',
        'uint32',
    ],
    [types_1.CommandContractType.AaveStopLossCommand]: ['address', 'uint16', 'address', 'address', 'uint256'],
    [types_1.CommandContractType.AaveStopLossCommandV2]: [
        'address',
        'uint16',
        'uint256',
        'address',
        'address',
        'uint256',
    ],
    [types_1.CommandContractType.MakerStopLossCommandV2]: ['uint256', 'uint16', 'uint256', 'uint256'],
    [types_1.CommandContractType.MakerAutoTakeProfitCommandV2]: ['uint256', 'uint16', 'uint256', 'uint32'],
    [types_1.CommandContractType.MakerBasicBuyCommandV2]: [
        'uint256',
        'uint16',
        'uint256',
        'uint256',
        'uint256',
        'uint256',
        'bool',
        'uint64',
        'uint32',
    ],
    [types_1.CommandContractType.MakerBasicSellCommandV2]: [
        'uint256',
        'uint16',
        'uint256',
        'uint256',
        'uint256',
        'uint256',
        'bool',
        'uint64',
        'uint32',
    ],
};
function getCommandAddresses(network) {
    if (!(network in exports.commandAddressMapping)) {
        throw new Error(`Command addresses for network ${network} not found. Supported networks: ${Object.keys(exports.commandAddressMapping).join(', ')}.`);
    }
    const mappingForNetwork = exports.commandAddressMapping[network];
    return Object.entries(mappingForNetwork).reduce((agg, [address, { type }]) => (Object.assign(Object.assign({}, agg), { [type]: (agg[type] || []).concat([address]) })), {});
}
exports.getCommandAddresses = getCommandAddresses;
function getDefinitionForCommandType(type) {
    if (!(type in exports.defaultCommandTypeMapping)) {
        throw new Error(`Unknown command type ${type}. Supported types: ${Object.keys(exports.defaultCommandTypeMapping).join(', ')}.`);
    }
    return exports.defaultCommandTypeMapping[type];
}
exports.getDefinitionForCommandType = getDefinitionForCommandType;
function getDefinitionForCommandAddress(address, network) {
    var _a;
    const info = getCommandContractInfo(address, network);
    return (_a = info.overwrite) !== null && _a !== void 0 ? _a : getDefinitionForCommandType(info.type);
}
exports.getDefinitionForCommandAddress = getDefinitionForCommandAddress;
function getCommandContractInfo(address, network) {
    if (!(network in exports.commandAddressMapping)) {
        throw new Error(`Command addresses for network ${network} not found. Supported networks: ${Object.keys(exports.commandAddressMapping).join(', ')}.`);
    }
    const mappingForNetwork = exports.commandAddressMapping[network];
    const lowercaseAddress = address.toLowerCase();
    if (!(lowercaseAddress in mappingForNetwork)) {
        throw new Error(`Command address ${lowercaseAddress} for network ${network} not found. Supported Addresses: ${JSON.stringify(mappingForNetwork)}`);
    }
    return mappingForNetwork[lowercaseAddress];
}
exports.getCommandContractInfo = getCommandContractInfo;
//# sourceMappingURL=mapping.js.map